import React from "react";
import CricketPage from "./exchange/member/CricketPage";
import { useGetSoccerMatchesQuery } from "../../store/services/mainApi";
import Loader from "../components/Loader";
import Error from "../components/Error";

export default function PrivateSoccerScreen() {
  // const { data, isFetching, error } = useGetSoccerMatchesQuery();

  // if (isFetching) {
  //   return <Loader />;
  // }
  // if (error) {
  //   return <Error />;
  // }
  // console.log(data);
  return (
    <>
      <CricketPage
      // activeName="Soccer"
      // activeApi={[{ title: "Soccer", active: true }]}
      // soccerMatch={data}
      />
      ;
    </>
  );
}
